var _g;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChat = function SvgChat(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 459.58 459.58",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.94 125.69V43.547c0-9.74 9.306-13.806 15.056-13.806h290.98c7.875 0 13.549 7.737 13.549 13.674v187.32c0 6.375-9.392 12.26-12.385 12.26h-51.055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 170.69h289.64c10.023 0 15 8 15 15v183.39c0 9.376-7.909 15-15 15h-99.316l-34.026 40.454c-6.816 6.816-15.355 7.603-22.958 0l-34.026-40.454H29.998c-7.51 0-15-5.5-15-15V185.69c0-8.839 6.8-15 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M80.011 242.79h189.62M80.011 310.57h77.621"
  }))));
};
export default SvgChat;